export default {
      id: "icon-check-usage",
      viewBox: "0 0 12 10",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-check",
      toString: function () {
        return this.url;
      }
    }